import { useLazyQuery, useMutation } from "@apollo/client";
import React, { useEffect, useState } from "react";
import { NotificationManager } from "react-notifications";
import { messages } from "../../util/message";
import { clientWellness } from "../../App";
import ListOfMyGames from "../../components/ListOfMyGames/ListOfMyGames";
import GameManagerTabs from "../../components/GameManagerTabs/GameManagerTabs";
import {
  ALL_MY_GAMES_ADMIN_FIRST,
  ALL_MY_GAMES_ADMIN_AFTER,
  ALL_MY_GAMES_ADMIN_BEFORE,
} from "../../GraphQL/Queries";
import {
  GeneralStyle,
  TableContainer,
} from "./GamesManagementContainer.styled";
import { useHistory } from "react-router-dom";
import { UPDATE_GAME_STATUS } from "../../GraphQL/Mutations";
import ModalConfirmAction from "../../components/ModalConfirmAction/ModalConfirmAction";
import { ReactComponent as GamificationIcon } from "../../assets/svg/gamification-header-icon.svg";
import HeaderComponent from "../../components/Header/Header";

const GamesManagementContainer = () => {
  const history = useHistory();
  const [anchorEl, setAnchorEl] = useState(null);
  const [myGames, setMyGames] = useState([]);
  const [pendingRows, setPendingRows] = useState(() => new Set());
  const [mygame, setMyGame] = useState({});
  const [openDeleteModal, setOpenDeleteModal] = useState(null);
  const [anchorSelected, setAnchorSelected] = useState(null);
  const [selectedMenu, selectMenu] = useState(["mygames", "My Games"]);
  const [formTrigger, setFormTrigger] = useState("");
  const [valueTabs, setValueTabs] = useState(0);
  const [renderAgain, setrenderAgain] = useState(false);
  const [updateMyGameStatus] = useMutation(UPDATE_GAME_STATUS, {
    client: clientWellness,
  });
  const [searchTxt, setSearchTxt] = useState("");
  const [allPages, setAllPages] = useState(null);
  const [startCursor, setStartCursor] = useState("");
  const [endCursor, setEndCursor] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [rowsPerPageOptions] = useState([5, 10, 20]);

  useEffect(() => {
    if (formTrigger !== selectedMenu[0]) {
      setFormTrigger("");
    }
    if (formTrigger === selectedMenu[0]) {
      setFormTrigger(selectedMenu[0]);
    }
    if (formTrigger === "mygames") {
      setTimeout(() => {
        history.push({ pathname: "/CreateGame" });
      }, 0);
    }
    if (formTrigger === "editMyGame") {
      setTimeout(() => {
        history.push({ pathname: "/CreateGame", state: { mygame: mygame } });
      }, 0);
    }
  }, [formTrigger, selectedMenu]);

  const [
    runQueryAllMyGamesManagementFirst,
    { loading: loadingMyGamesFirst, error: errorMyGamesFirst },
  ] = useLazyQuery(ALL_MY_GAMES_ADMIN_FIRST, {
    client: clientWellness,
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      asignData(data);
    },
  });

  const [
    runQueryAllMyGamesManagementAfter,
    { loading: loadingMyGamesAfter, error: errorMyGamesAfter },
  ] = useLazyQuery(ALL_MY_GAMES_ADMIN_AFTER, {
    client: clientWellness,
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      asignData(data);
    },
  });

  const [
    runQueryAllMyGamesManagementBefore,
    { loading: loadingMyGamesBefore, error: errorMyGamesBefore },
  ] = useLazyQuery(ALL_MY_GAMES_ADMIN_BEFORE, {
    client: clientWellness,
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      asignData(data);
    },
  });

  const asignData = (data) => {
    setAllPages(data?.gamesAdministration?.totalCount);
    if (data?.gamesAdministration?.pageInfo?.hasNextPage === true) {
      setEndCursor(data?.gamesAdministration?.pageInfo?.endCursor);
    }
    if (data?.gamesAdministration?.pageInfo?.hasPreviousPage === true) {
      setStartCursor(data?.gamesAdministration?.pageInfo?.startCursor);
    }
    let allGames = data?.gamesAdministration?.edges.map((game) => {
      return {
        id: game.node.gameId,
        name: game.node.name,
        topic: game.node.topic,
        countryName: game.node.countryName,
        cityName: game.node.cityName,
        createUser: game.node.createUser,
        recordState: game.node.status,
        userAssigned: game.node.usersAssigned,
      };
    });
    setMyGames(allGames);
  };

  useEffect(() => {
    if (!searchTxt) {
      runQueryAllMyGamesManagementFirst({
        variables: {
          first: rowsPerPage,
          searchBy: "",
        },
      });
    } else {
      runQueryAllMyGamesManagementFirst({
        variables: {
          first: rowsPerPage,
          searchBy: searchTxt,
        },
      });
    }
  }, [rowsPerPage, searchTxt]);

  let handleClickActions = (space, rowData) => {
    setAnchorEl(space.currentTarget);
    setAnchorSelected(rowData.id);
  };

  let handleEditGame = (rowData) => {
    setMyGame(rowData);
    setAnchorEl(null);
    setAnchorSelected(null);
    setFormTrigger("editMyGame");
  };

  const handleChangePage = (event, newPage) => {
    if (newPage > page) {
      runQueryAllMyGamesManagementAfter({
        variables: {
          first: rowsPerPage,
          after: endCursor,
          searchBy: searchTxt,
        },
      });
    }
    if (newPage < page) {
      runQueryAllMyGamesManagementBefore({
        variables: {
          last: rowsPerPage,
          before: startCursor,
          searchBy: searchTxt,
        },
      });
    }
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value ? parseInt(event.target.value) : 10);
    setPage(0);
    runQueryAllMyGamesManagementFirst({
      variables: {
        first: event.target.value ? parseInt(event.target.value) : 10,
        searchBy: searchTxt,
      },
    });
  };

  const applyGameState = (id, nextState) => (prev) =>
    prev.map((g) => (g.id === id ? { ...g, recordState: nextState } : g));

  const revertToOppositeState = (id, fromState) => (prev) =>
    prev.map((g) =>
      g.id === id
        ? { ...g, recordState: fromState === "Active" ? "Inactive" : "Active" }
        : g
    );

  const excludeGame = (id) => (prev) => prev.filter((g) => g.id !== id);

  let updateMyGameState = (rowData, state) => {
    if (pendingRows.has(rowData.id)) return;
    let newState = state.toUpperCase();

    // Optimistic update: flip UI immediately to avoid flicker on the switch
    if (state !== "Deleted") {
      setMyGames(applyGameState(rowData.id, state));
    }

    setPendingRows((prev) => new Set(prev).add(rowData.id));

    updateMyGameStatus({
      variables: {
        gameId: rowData.id,
        newStatus: newState,
      },
    }).then((response) => {
      setPendingRows((prev) => {
        const next = new Set(prev);
        next.delete(rowData.id);
        return next;
      });
      if (response.data.changeGameStatus.status) {
        if (state === "Deleted") {
          setMyGames(excludeGame(rowData.id));
          NotificationManager.success(messages.GameDeletedSuccess, "", 5000);
        } else {
          NotificationManager.success(messages.GameStatusUpdatedSuccess, "", 5000);
        }
      } else {
        // Revert optimistic update on API failure
        if (state !== "Deleted") {
          setMyGames(revertToOppositeState(rowData.id, state));
        }
        NotificationManager.error(messages.GenericError, "", 5000);
      }
    }).catch(() => {
      setPendingRows((prev) => {
        const next = new Set(prev);
        next.delete(rowData.id);
        return next;
      });
      // Revert optimistic update on network error
      if (state !== "Deleted") {
        setMyGames(revertToOppositeState(rowData.id, state));
      }
      NotificationManager.error(messages.GenericError, "", 5000);
    });
  };

  let handleCloseActions = () => {
    setAnchorEl(null);
    setAnchorSelected(null);
  };

  let toggleChecked = (rowData) => {
    if (pendingRows.has(rowData.id)) return;
    updateMyGameState(
      rowData,
      rowData.recordState === "Active" ? "Inactive" : "Active"
    );
  };

  let deleteMyGame = (rowData) => {
    updateMyGameState(rowData, "Deleted");
    setOpenDeleteModal(null);
  };

  const showDeleteModal = () => {
    return openDeleteModal ? (
      <ModalConfirmAction
        title={"Are you sure you want to delete this game?"}
        open={openDeleteModal}
        setOpen={setOpenDeleteModal}
        fn={deleteMyGame}
      />
    ) : null;
  };

  const showSelectedMenuTable = (selectedMenu) => {
    switch (selectedMenu[0]) {
      case "mygames":
        return (
          <ListOfMyGames
            loadingMyGamesFirst={loadingMyGamesFirst}
            loadingMyGamesAfter={loadingMyGamesAfter}
            loadingMyGamesBefore={loadingMyGamesBefore}
            errorMyGamesFirst={errorMyGamesFirst}
            errorMyGamesAfter={errorMyGamesAfter}
            errorMyGamesBefore={errorMyGamesBefore}
            myspaces={myGames}
            toggleChecked={toggleChecked}
            pendingRows={pendingRows}
            handleClickActions={handleClickActions}
            anchorEl={anchorEl}
            anchorSelected={anchorSelected}
            handleCloseActions={handleCloseActions}
            handleEditSpace={handleEditGame}
            setAnchorEl={setAnchorEl}
            setAnchorSelected={setAnchorSelected}
            setOpenDeleteModal={setOpenDeleteModal}
            allPages={allPages}
            page={page}
            rowsPerPage={rowsPerPage}
            rowsPerPageOptions={rowsPerPageOptions}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
          />
        );
      default:
        break;
    }
  };

  return (
    <GeneralStyle>
      <HeaderComponent
        Icon={GamificationIcon}
        text={"Gamification"}
        notIncludeHeight={true}
      />
      <GameManagerTabs
        selectedMenu={selectedMenu}
        selectMenu={selectMenu}
        setFormTrigger={setFormTrigger}
        setValueTabs={setValueTabs}
        valueTabs={valueTabs}
        searchTxt={searchTxt}
        setSearchTxt={setSearchTxt}
        renderAgain={renderAgain}
        setrenderAgain={setrenderAgain}
      />
      <hr className="table-separator" />
      <TableContainer>{showSelectedMenuTable(selectedMenu)}</TableContainer>
      {showDeleteModal()}
    </GeneralStyle>
  );
};

export default GamesManagementContainer;
